export default __webpack_public_path__ + "static/media/sendDisable.94a14490.svg";